import { useState, useEffect, useContext } from 'react';
import { AsgFwContext, ToolsContext } from '../contexts';

export const useLiveCasinoState = (
    cb,
    dependencies = [],
) => {
    const [intervalId, setIntervalId] = useState(null);
    const AsgFW = useContext(AsgFwContext);
    const Tools = useContext(ToolsContext);

    const setLiveCasinoComponentsState = async () => {
        try {
            const betLimits = AsgFW.getLiveCasinoBetLimits();
            const state = await AsgFW.getLiveCasinoState();

            cb({
                betLimits,
                state,
            });
        } catch (e) {
            Tools.log(`Live casino fetch failed ${e.message}`);
        }
    };

    const unsubscribeFromUpdates = () => {
        clearInterval(intervalId);
        setIntervalId(null);
    };

    useEffect(() => {
        if (intervalId) {
            unsubscribeFromUpdates();
        }

        // initial data retrieve
        setLiveCasinoComponentsState();

        // subscribe for updates
        setIntervalId(setInterval(setLiveCasinoComponentsState, 20000));

        return () => {
            unsubscribeFromUpdates();
        };
    }, dependencies);
};
